export default __webpack_public_path__ + "static/media/MaleStudent.bd970c86.svg";